import { gql, useMutation } from '@apollo/client';

import {
  ListingPresentationScheduled,
  ListingPresentationScheduledVariables,
} from '../../../graphql/athena/mutations/__generated__/ListingPresentationScheduled';
import { LWC_DETAILS_QUERY } from '../../../graphql/athena/queries/LwcDetails';
import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from '../queries/BrokerageLwcDetails';

export const LISTING_PRESENTATION_SCHEDULED = gql`
  mutation ListingPresentationScheduled(
    $lwcProductId: String!
    $listingPresentationScheduled: DateTime!
  ) {
    odProtosListingsServicesListwithcertaintyproduct {
      listingPresentationScheduled(
        input: {
          lwcProductId: $lwcProductId
          listingPresentationDate: $listingPresentationScheduled
        }
      ) {
        _empty
      }
    }
  }
`;

/**
 * Previous state: FIRST_CONTACT_ATTEMPTED
 * transitions to state: LISTING_PRESENTATION_SCHEDULED
 * Meant to document the tentative date that the listing presentation is scheduled for
 */

export const useListingPresentationScheduled = () => {
  const [updateListingPresentationScheduled, { data, error, loading }] = useMutation<
    ListingPresentationScheduled,
    ListingPresentationScheduledVariables
  >(LISTING_PRESENTATION_SCHEDULED, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [LWC_DETAILS_QUERY, LWC_DETAILS_FOR_BROKERAGE_QUERY],
  });

  const setListingPresentationScheduled = (
    lwcProductId: string,
    listingPresentationScheduled: string,
  ) =>
    updateListingPresentationScheduled({
      variables: { lwcProductId, listingPresentationScheduled },
    });
  return { setListingPresentationScheduled, data, loading, error };
};
